import { object, string, ref } from 'yup';

export const validationSchema = object({
  confirm_password: string()
    .oneOf([ref('password'), null], 'Passwords mismatch')
    .required(),
  password: string().required().min(6, 'The password should contain min. 6 characters.'),
});
